module.exports =  {
	WECHAT_APP_ID:'wx277d4f2c336548bd',
	WECHAT_AUTH_URL:'https://api.kingmaimai.com/ddkunion/auth',
	WECHAT_AUTH_STATE:location.host.split('.')[0]
}